import * as yup from 'yup';
import CrudPage from '@modules/cruds/CrudPage';
import TaskForm from './TaskForm';
import { defaultConfigComponent } from './Tasks';

const taskSchema = yup.object().shape({
  description: yup.string().required().label('Description'),
});

const TaskPage = props => {
  const defaultValues = {
    isMandatory: false,
    separatedTask: false,
    relatedItems: [],
    relatedPeople: [],
    percentageCompletion: 0,
    logEventUponStatusChange: false,
    isCompleted: false,
    successiveTask: false,
    recordDate: new Date(),
    recordTime: new Date(),
    calendarDays: true,
    currentStatus: { indicators: [] },
    documents: [],
    warningBeforeUnits: 'days',
    dueFromRecordUnits: 'days',
  };

  return (
    <CrudPage
      {...props}
      key={'taskPage'}
      configComponent={defaultConfigComponent}
      form={TaskForm}
      defaultValues={defaultValues}
      validationSchema={taskSchema}
      essentialValues={new Set(['relatedItems', 'relatedPeople'])}
    />
  );
};

export default TaskPage;
